import { isEmpty, isNil } from 'lodash';
function extractQueryNames(query) {
    return query?.definitions
        ?.map((def) => def?.name?.value || '')
        .join(',');
}
function getErrorObjectFromGraphQLErrors(graphqlError, query, errorMappingContext) {
    const nwError = graphqlError?.networkError;
    if (!nwError?.result?.errors &&
        isEmpty(graphqlError?.graphQLErrors)) {
        return [
            {
                queryName: extractQueryNames(query),
                code: 'NW_ERROR',
                message: '',
                errorObj: nwError,
                errorMappingContext,
            },
        ];
    }
    const errs = graphqlError?.networkError?.result?.errors ||
        graphqlError?.graphQLErrors;
    if (!errs)
        return undefined;
    const errors = errs.map(e => {
        return {
            queryName: query?.definitions
                ?.map((def) => def?.name?.value || '')
                .join(','),
            code: e?.extensions?.code || 'ERROR_UNKNOWN_ERROR',
            message: e?.message,
            errorObj: e,
            errorMappingContext,
        };
    });
    return errors;
}
export function getErrorCodeFromGraphQLErrors(graphqlError) {
    const errorObj = getErrorObjectFromGraphQLErrors(graphqlError) || [];
    const errorCode = errorObj[0]?.errorObj?.extensions.exception.upstreamResponse.data.code;
    return errorCode ? errorCode.toString() : undefined;
}
function getDebugMessageFromGraphQLErrors(graphqlError, translation) {
    const errorObj = getErrorObjectFromGraphQLErrors(graphqlError) || [];
    const debug = errorObj[0]?.errorObj?.extensions?.exception?.upstreamResponse?.data
        ?.debug;
    try {
        return debug
            ? JSON.parse(debug)[0]
            : translation('error.validation.default');
    }
    catch (e) {
        return translation('customChart.error.genericError');
    }
}
export const fallBackErrorCodes = [
    '10606',
    '10007',
    '10002',
    '10003',
    '13003',
];
export const getErrorInfoWithFallback = (error, translation) => {
    if (isNil(error)) {
        return null;
    }
    const code = getErrorCodeFromGraphQLErrors(error);
    const message = fallBackErrorCodes.includes(code)
        ? getDebugMessageFromGraphQLErrors(error, translation)
        : translation('error.validation.default');
    const errInfo = {
        message,
        code,
    };
    return errInfo;
};
//# sourceMappingURL=error-handling-utils.js.map